import { useRef as s, useCallback as m, useEffect as v } from "react";
const T = ({ currentEnv: u, allowedEnvs: d }) => {
  const i = s(null), a = s(null), l = s(null), c = m(() => {
    const e = document.querySelector("main");
    e ? p(e) : l.current = setTimeout(c, 100);
  }, []), f = m((e) => {
    const t = e.querySelector(".Campaign");
    let r = !1;
    if (!t) {
      const n = (o) => {
        const C = e.id, h = g(C);
        o.detail.Campaign.id === h && (document.removeEventListener("om.Campaign.show", n), r = !0);
      };
      document.addEventListener("om.Campaign.show", n), a.current = setTimeout(() => {
        const o = e.querySelector(".Campaign");
        !r && !o && window.om2863_27375 && window.om2863_27375.reset(), document.removeEventListener("om.Campaign.show", n);
      }, 1e3);
    }
  }, []), p = m((e) => {
    i.current || (i.current = new MutationObserver((t) => {
      t.forEach((r) => {
        r.type === "childList" && r.addedNodes.forEach((n) => {
          if (n.nodeType === Node.ELEMENT_NODE) {
            const o = n.querySelector('[id^="om-"][id$="-holder"]');
            o && (clearTimeout(a.current), f(o));
          }
        });
      });
    })), i.current.observe(e, { childList: !0, subtree: !0 });
  }, [f]), g = (e) => {
    const t = e.match(/^om-(.*?)-holder$/);
    return t ? t[1] : null;
  };
  return v(() => (d.includes(u) && c(), () => {
    var e;
    (e = i.current) == null || e.disconnect(), clearTimeout(a.current), clearTimeout(l.current);
  }), [c, u, d]), c;
};
export {
  T as useOptinMonsterReset
};
